import styled from "styled-components";
import Image from "next/image";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { useTrackVisibility } from "react-intersection-observer-hook";

import { IconSoftInventory, IconSoftMaintenance, IconSoftAionics } from "@/assets/images";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { HeaderSection } from "../../Cards";
import { useEffect, useState } from "react";

const { useBreakpoint } = Grid;

export function ContactUsAdditionalContact({ additional_contact = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);

	return (
		<Container ref={ref}>
			<Row align="top" gutter={[12, 12]} style={{ opacity: visible ? 1 : 0 }}>
				<Col xxl={8} xl={10} md={10} sm={12} xs={24}>
					<WrapperContent className={`${visible && "animate__animated animate__fadeInUp"}`}>
						<RATypography variant={screens?.xs ? "h3" : "h2"} whiteSpace="pre-wrap">
							{additional_contact?.title || ""}
						</RATypography>
					</WrapperContent>
				</Col>
				<Col xxl={16} xl={14} md={14} sm={12} xs={24}>
					<div className={`${visible && "animate__animated animate__fadeInUp"}`}>
						<RATypography variant="body3" top="12px" color="#595959">
							{additional_contact?.sub_title || ""}
						</RATypography>
					</div>
				</Col>
			</Row>
			<div style={{ position: "relative", width: "100%" }}>
				<MainImageRow>
					<Row justify="center" style={{ width: "100%", height: "100%" }}>
						<div
							style={{
								width: "100%",
								height: screens.xs ? "225px" : "38vh",
								maxWidth: "90vw",
								position: "relative",
							}}
						>
							<RAImage
								url={
									screens.xs
										? additional_contact?.mobile_background_photo
										: additional_contact?.desktop_background_photo ||
											PATH_PUBLIC_IMAGES.service_af_experience
								}
								fill
								quality={100}
								sizes={"100vw"}
								borderRadius="12px"
								style={{
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						</div>
					</Row>
				</MainImageRow>
				<Padding>
					<ThirdRow gutter={[28, 20]}>
						<CardSectionItem
							icon={<RAImage url={IconSoftInventory} width={44} height={44} />}
							title={additional_contact?.contact1?.title || ""}
							description={formatPhoneNumberIntl(additional_contact?.contact1?.phone || "")}
							phone={additional_contact?.contact1?.phone}
						/>
						<CardSectionItem
							icon={<RAImage url={IconSoftMaintenance} width={44} height={44} />}
							title={additional_contact?.contact2?.title || ""}
							description={formatPhoneNumberIntl(additional_contact?.contact2?.phone || "")}
							phone={additional_contact?.contact2?.phone}
						/>
						<CardSectionItem
							icon={<RAImage url={IconSoftAionics} width={44} height={44} />}
							title={additional_contact?.contact3?.title || ""}
							description={formatPhoneNumberIntl(additional_contact?.contact3?.phone || "")}
							phone={additional_contact?.contact3?.phone}
						/>
					</ThirdRow>
				</Padding>
			</div>
		</Container>
	);
}

const CardSectionItem = ({ icon, title = "", description = "", phone = "" }) => {
	const screens = useBreakpoint();
	return (
		<Col xl={8} lg={8} md={8} sm={24} xs={24}>
			<WrapperItem align="middle">
				<Col xxl={24} xl={24} lg={24} className="card-selection-item">
					{icon}
				</Col>
				<Col>
					<RATypography
						variant={screens.xs ? "sub-heading4" : "sub-heading3"}
						style={{ fontSize: screens.xs ? "16px" : "18px" }}
					>
						{title}
					</RATypography>
					<a href={`tel:${phone}`}>
						<RATypography variant="body2" color="#595959" top={4}>
							{description}
						</RATypography>
					</a>
				</Col>
			</WrapperItem>
		</Col>
	);
};

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 84px 0 0 0;
	@media (max-width: 576px) {
		padding: 20px 0;
	}
`;
const WrapperItem = styled(Row)`
	width: 100%;
	height: 100%;
	padding: 16px 20px;
	background: #f9f9f9;
	border-radius: 16px;
	.card-selection-item {
		margin-right: 24px;
	}
	@media (max-width: 767px) {
		.card-selection-item {
			margin-right: 18px;
		}
	}
	@media (max-width: 575px) {
		.card-selection-item {
			margin-right: 12px;
		}
	}
`;
const Padding = styled.div`
	padding: 24px 136px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 0;
	@media (max-width: 1200px) {
		padding: 16px 80px;
	}
	@media (max-width: 767px) {
		padding: 12px 32px;
	}
	@media (max-width: 575px) {
		padding: 8px 16px;
	}
`;
const MainImageRow = styled.div`
	margin-top: 24px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;
const ThirdRow = styled(Row)`
	width: 85%;
	position: relative;
	top: -95px;
	padding: 20px 0px;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	transition: all 0.3s ease-in-out;
	@media (max-width: 1200px) {
		width: 100%;
	}
	@media (max-width: 768px) {
		width: 95%;
	}
	@media (max-width: 575px) {
		top: -45px;
	}
`;
const WrapperContent = styled.div`
	padding: 4px 12px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
